import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { HomeIcon, UserIcon } from 'lucide-react';
export function Navigation() {
  const navigate = useNavigate();
  const location = useLocation();
  // Hide navigation on login page
  if (location.pathname === '/login') {
    return null;
  }
  const tabs = [{
    id: 'home',
    label: 'Accueil',
    icon: HomeIcon,
    path: '/'
  }, {
    id: 'profile',
    label: 'Profil',
    icon: UserIcon,
    path: '/profile'
  }];
  return <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 safe-area-inset-bottom" data-id="element-60">
      <div className="max-w-lg md:max-w-2xl lg:max-w-4xl mx-auto flex" data-id="element-61">
        {tabs.map(tab => {
        const Icon = tab.icon;
        const isActive = location.pathname === tab.path;
        return <button key={tab.id} onClick={() => navigate(tab.path)} className={`flex-1 flex flex-col items-center justify-center py-3 md:py-4 transition-colors duration-200 ${isActive ? 'text-amber-600' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-62">
              <Icon className={`w-6 h-6 md:w-7 md:h-7 mb-1 ${isActive ? 'stroke-2' : ''}`} data-id="element-63" />
              <span className={`text-xs md:text-sm ${isActive ? 'font-semibold' : 'font-medium'}`} data-id="element-64">
                {tab.label}
              </span>
            </button>;
      })}
      </div>
    </nav>;
}